export class RogueCaseMeeting {
  ID: number;
  PENDING_USER: string;
  PENDING_ACTION: string;
  PENDING_STATUS: string;
  RECOMMENDATION: string;
  CASE_TYPE: string;
  CASE_ASSIGNED: string;
  CPN: string;
  MSN: string;
  NOUN: string;
  DESCRIPTION: string;
  FLEET: string;
  LOCN: string;
  DEPT: string;
  STATUS: string;
  SO_NBR: string;
  TAG_NBR: string;
  CLAIM_NBR: number;
  FSC: string;
  VENDOR_NAME: string;
  MATERIEL_INVENTORY_SPECIALIST: string;
  REPAIR_TECHNICAL_SPECIALIST: string;
}
